import moment from 'moment';
import React from 'react'
import { Col, Row } from 'reactstrap';
import { TodoHistoryDTO, manualTodoHistory } from '../../../../models/TodoModel';
// import { TodoHistoryDTO } from '../../../Models/Compliance/History';

interface ITaskHistoryProps {
  taskHistory: TodoHistoryDTO[] | [];
}

const TaskHistory = (props: ITaskHistoryProps) => {
  return (
    <div>
      <div className="historyModel">
        {props?.taskHistory &&
          props?.taskHistory?.length > 0 ? (
          props?.taskHistory?.map((element: TodoHistoryDTO) => (
            <Row className="infoPack" key={element?.todoHistoryId}>
              <Col md="3">{element?.createdByName || "-"}</Col>
              <Col md="1" className="">
                {moment(moment.utc(element?.updatedDate)?.toDate())?.format('M/DD/YY') || "-"}
              </Col>
              <Col md="2" className="timeDate">
                {moment(moment.utc(element?.updatedDate)?.toDate())?.format('hh:mm A') || "-"} 
              </Col>
              <Col>{element?.taskInfo || "-"}</Col>
            </Row>
          ))
        ) : (
          <Row className="infoPack">
            <Col className='not-found'>No records found</Col>
          </Row>
        )}
      </div>
    </div>
  )
}

export default TaskHistory
